import { DefaultModel } from "../defaultModel";

export const TrendlineModel = DefaultModel.extend({
    defaults: () => ({
        ...DefaultModel.prototype.defaults,
        widgetType: "trendline"
    })
});
